import { render, staticRenderFns } from "./50x.vue?vue&type=template&id=2e5f06e0&scoped=true"
import script from "./50x.vue?vue&type=script&lang=js"
export * from "./50x.vue?vue&type=script&lang=js"
import style0 from "./50x.vue?vue&type=style&index=0&id=2e5f06e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f06e0",
  null
  
)

export default component.exports